/**
 * @generated SignedSource<<fa9c4a1f8003d0525cbaa9186d16457d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DocumentFormQuery$variables = {
  dependent?: string | null | undefined;
  documentType: string;
};
export type DocumentFormQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DocumentForm_query">;
};
export type DocumentFormQuery = {
  response: DocumentFormQuery$data;
  variables: DocumentFormQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dependent"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "documentType"
},
v2 = {
  "kind": "Variable",
  "name": "documentType",
  "variableName": "documentType"
},
v3 = [
  {
    "kind": "Variable",
    "name": "dependent",
    "variableName": "dependent"
  },
  (v2/*: any*/)
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v8 = [
  (v7/*: any*/),
  (v5/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "DocumentFormQuery",
    "selections": [
      {
        "args": (v3/*: any*/),
        "kind": "FragmentSpread",
        "name": "DocumentForm_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "DocumentFormQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Candidate",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "state",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "company",
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyDomainName",
        "plural": false,
        "selections": [
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "dependent",
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "dependent"
          }
        ],
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "CandidateDocument",
        "kind": "LinkedField",
        "name": "candidateDocumentByDocumentType",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DocumentData",
            "kind": "LinkedField",
            "name": "documentData",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fieldName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fieldValue",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DocumentFile",
            "kind": "LinkedField",
            "name": "files",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "file",
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "File",
                "kind": "LinkedField",
                "name": "fileSchema",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "preSignedUrl",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Document",
            "kind": "LinkedField",
            "name": "documentType",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Fields",
                "kind": "LinkedField",
                "name": "fields",
                "plural": true,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Files",
                "kind": "LinkedField",
                "name": "files",
                "plural": true,
                "selections": (v8/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          (v2/*: any*/)
        ],
        "concreteType": "Document",
        "kind": "LinkedField",
        "name": "document",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Files",
            "kind": "LinkedField",
            "name": "files",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Fields",
            "kind": "LinkedField",
            "name": "fields",
            "plural": true,
            "selections": [
              (v7/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "mask",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6c77e8907e98172e075db3814145c2ad",
    "id": null,
    "metadata": {},
    "name": "DocumentFormQuery",
    "operationKind": "query",
    "text": "query DocumentFormQuery(\n  $documentType: String!\n  $dependent: ID\n) {\n  ...DocumentForm_query_4dfA5H\n}\n\nfragment DocumentFormDatePickerField_field on Fields {\n  label\n  name\n  type\n  value\n  mask\n}\n\nfragment DocumentFormFile_candidate on Candidate {\n  id\n}\n\nfragment DocumentFormFile_candidateDocument on CandidateDocument {\n  id\n  files {\n    file\n    name\n    fileSchema {\n      preSignedUrl\n      id\n    }\n  }\n}\n\nfragment DocumentFormFile_dependent on CandidateDependent {\n  id\n}\n\nfragment DocumentFormFile_document on Document {\n  code\n}\n\nfragment DocumentFormFile_file on Files {\n  name\n  label\n}\n\nfragment DocumentFormFiles_candidate on Candidate {\n  id\n  ...DocumentFormFile_candidate\n}\n\nfragment DocumentFormFiles_candidateDocument on CandidateDocument {\n  id\n  files {\n    file\n    name\n    fileSchema {\n      preSignedUrl\n      id\n    }\n  }\n  ...DocumentFormFile_candidateDocument\n}\n\nfragment DocumentFormFiles_dependent on CandidateDependent {\n  id\n  ...DocumentFormFile_dependent\n}\n\nfragment DocumentFormFiles_document on Document {\n  ...DocumentFormFile_document\n  code\n  files {\n    name\n    label\n    ...DocumentFormFile_file\n  }\n}\n\nfragment DocumentFormLinkField_field on Fields {\n  label\n  name\n  type\n  value\n  mask\n}\n\nfragment DocumentFormSelectField_field on Fields {\n  label\n  name\n  type\n  value\n  mask\n}\n\nfragment DocumentFormTextField_field on Fields {\n  label\n  name\n  type\n  value\n  mask\n}\n\nfragment DocumentForm_query_4dfA5H on Query {\n  me {\n    id\n    address {\n      state\n    }\n    ...DocumentFormFiles_candidate\n  }\n  company: companyDomainName {\n    id\n  }\n  dependent: node(id: $dependent) {\n    __typename\n    ... on CandidateDependent {\n      id\n      ...DocumentFormFiles_dependent\n    }\n    id\n  }\n  candidateDocumentByDocumentType(documentType: $documentType, dependent: $dependent) {\n    id\n    companyStatus\n    documentData {\n      fieldName\n      fieldValue\n    }\n    ...DocumentFormFiles_candidateDocument\n    files {\n      file\n      name\n    }\n    documentType {\n      name\n      description\n      fields {\n        label\n        name\n      }\n      files {\n        label\n        name\n      }\n    }\n  }\n  document(documentType: $documentType) {\n    ...DocumentFormFiles_document\n    name\n    description\n    code\n    files {\n      name\n      label\n    }\n    fields {\n      label\n      name\n      type\n      value\n      mask\n      ...DocumentFormSelectField_field\n      ...DocumentFormDatePickerField_field\n      ...DocumentFormLinkField_field\n      ...DocumentFormTextField_field\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c7be5c60b3bd35f4ba1a494222d39e49";

export default node;
